import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import './App.scss'
import Home from './pages/Home'


function App() {
  return (
    <Router basename="/holidaygame">
      <div className="App">
        <Switch>
          <Route path="/" component={Home} />
        </Switch>
      </div>
    </Router>
  );
}

export default App;
